import Repository from "./RepositoryLocal";

const resource = "/kawabou";
export default {
  /**
   * 設定ファイル取得
   */
  getSetting() {
    let fileNm = "setting.json";
    if (global.KWB_MODE === "reduction") {
      // 簡易版の場合、専用ファイルを取得
      fileNm = "miniSetting.json";
    }
    return Repository.get(`${resource}/Config/` + fileNm);
  },
};
